import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * « Intégration » left the « Paramètres » menu for Super-administration ›
 * « Contrat d'une organisation » (#3061). Old links and bookmarks land on the
 * same organization's contract instead of a not-found page.
 */
export const Route = createFileRoute(
  '/_authenticated/org/$orgId/settings/integration'
)({
  beforeLoad({ params }) {
    throw redirect({
      to: '/super-admin',
      search: { tab: 'contract', org: params.orgId },
      replace: true,
    })
  },
})
